import axios from './axios'

const getAppVersionBuilds = () => axios.get('/bitrise/artifacts')
export default getAppVersionBuilds
